import Swiper from 'swiper/bundle'

window.customElements.define('curated-collection', class CuratedCollection extends HTMLElement {
  constructor() {
    super()
    this.handleQuickShopClick = this.handleQuickShopClick.bind(this)
  }

  connectedCallback() {
    this.addEventListener('click', this.handleQuickShopClick, true)

    const tabs = Array.from(this.querySelectorAll('.curated-collection__tab'))
    const panels = Array.from(this.querySelectorAll('.curated-collection__panel'))
    const links = Array.from(this.querySelectorAll('.curated-collection__view-more'))

    const activate = (index) => {
      tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.tab === index))
      panels.forEach((p) => p.classList.toggle('is-hidden', p.dataset.tabPanel !== index))
      links.forEach((l) => l.classList.toggle('is-hidden', l.dataset.tabLink !== index))
      window.dispatchEvent(new Event('resize'))
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.tab))
    })

    if (tabs.length) activate(tabs[0].dataset.tab)

    const swiperConfig = {
      slidesPerView: 2.2,
      spaceBetween: 16,
      breakpoints: {
        768: { slidesPerView: 2.5 },
        1024: { slidesPerView: 3.5 },
        1280: { slidesPerView: 'auto' },
      },
      pagination: { el: '.swiper-pagination' },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }

    const initSwipers = () => Array.from(this.querySelectorAll('.product-carousel.swiper-container'))
      .map((carousel) => new Swiper(carousel, swiperConfig))

    let swipers = initSwipers()

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => { swipers = initSwipers() })
      document.addEventListener('shopify:section:unload', () => { swipers.forEach((swiper) => swiper.destroy()) })
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleQuickShopClick, true)
  }

  async handleQuickShopClick(event) {
    const button = event.target.closest('.card-v2 .quickshop-btn')
    if (!button) return

    const card = button.closest('.card-v2')
    if (!card) return

    event.preventDefault()
    event.stopPropagation()
    const { renderQuickShop } = await import('./quickshop/render-quickshop')
    renderQuickShop(card)
  }
})
